import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

import { Configuration } from '../../config';
export class ConfigService {
private config: any;
/**
 * @param {?} http
 */
constructor(private http: HttpClient) { }
/**
 * @param {?} url
 * @return {?}
 */
load(url: string) {
    const /** @type {?} */ headers = new HttpHeaders().set('fusion-config', 'fusion-config.json');

    return new Promise((resolve) => {
      this.http.get<Configuration>(url, { headers: headers }).map(res => {
        return res
      })
      .catch((error: any): any => {
        resolve(true);
        return Observable.throw(error.json().error || 'Server error');
      })
      .subscribe(config => {
        this.config = config;
        resolve();
      },
      (err) => {
      },
      () => {
      });
    }).catch((err) => {
    });
  }
/**
 * @return {?}
 */
getConfiguration(): Configuration {
    return this.config;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
];
}

function ConfigService_tsickle_Closure_declarations() {
/** @type {?} */
ConfigService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfigService.ctorParameters;
/** @type {?} */
ConfigService.prototype.config;
/** @type {?} */
ConfigService.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
